var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cfl-page" },
    [
      _c("div", { staticClass: "cfl-toolbar" }, [
        _c("div", { staticClass: "cfl-toolbar-left" }, [
          _c("h1", { staticClass: "cfl-title" }, [_vm._v("Forms")]),
          _vm._v(" "),
          _vm.totalForms
            ? _c("span", { staticClass: "cfl-count" }, [
                _vm._v(_vm._s(_vm.totalForms))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cfl-toolbar-right" },
          [
            _c(
              "el-form",
              {
                nativeOn: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.searchForms($event)
                  }
                }
              },
              [
                _c("el-input", {
                  staticClass: "cfl-search",
                  attrs: {
                    clearable: "",
                    type: "text",
                    placeholder: "Search forms…",
                    "prefix-icon": "el-icon-search"
                  },
                  on: { clear: _vm.refetchItems },
                  model: {
                    value: _vm.searchFormsKeyWord,
                    callback: function($$v) {
                      _vm.searchFormsKeyWord = $$v
                    },
                    expression: "searchFormsKeyWord"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("DateFilter", {
              attrs: { filter_date_range: _vm.filter_date_range },
              on: {
                "update:filter_date_range": function($event) {
                  _vm.filter_date_range = $event
                },
                "date-filter-changed": _vm.onDateFilterChanged
              }
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "cfl-add-btn",
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.showAddFormModal = true
                  }
                }
              },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _vm._v(" Add New Form\n      ")
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "cfl-table-wrap"
        },
        [
          _vm.forms !== null
            ? _c(
                "el-table",
                {
                  staticClass: "cfl-table",
                  attrs: {
                    data: _vm.paginatedData,
                    "row-class-name": "cfl-row"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "Form", "min-width": "260" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "cfl-form-cell" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "cfl-avatar",
                                    style: {
                                      background: _vm.avatarColor(scope.row.id)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.initials(scope.row.name)) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "cfl-form-info" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "cfl-form-name",
                                      attrs: {
                                        href:
                                          _vm.admin_url +
                                          "?page=contactum&route=builder#/forms/" +
                                          scope.row.id
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "cfl-row-actions" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.admin_url +
                                              "?page=contactum&route=builder#/forms/" +
                                              scope.row.id
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit-outline"
                                          }),
                                          _vm._v(" Edit\n                ")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "cfl-sep" }, [
                                        _vm._v("|")
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "cfl-sep" }, [
                                        _vm._v("|")
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "cfl-danger",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.removeFormConfirmation(
                                                scope.row.id,
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete"
                                          }),
                                          _vm._v(" Delete\n                ")
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      851354170
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Shortcode", width: "220" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "code",
                                {
                                  staticClass: "cfl-shortcode copy",
                                  attrs: {
                                    "data-clipboard-text":
                                      '[contactum id="' + scope.row.id + '"]',
                                    title: "Click to copy"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-document-copy"
                                  }),
                                  _vm._v(
                                    '\n            [contactum id="' +
                                      _vm._s(scope.row.id) +
                                      '"]\n          '
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1867836427
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Created", width: "160" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", { staticClass: "cfl-date" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      scope.row.data && scope.row.data.post_date
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2733904187
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Entries", width: "100", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "cfl-entries-badge",
                                  class:
                                    scope.row.entries > 0
                                      ? "cfl-entries-badge--has"
                                      : "",
                                  attrs: {
                                    href:
                                      _vm.admin_url +
                                      "?page=contactum&route=builder#/forms/entries/" +
                                      scope.row.id
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.entries || 0))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4115716128
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.forms && _vm.forms.length === 0
            ? _c("div", { staticClass: "cfl-empty" }, [
                _c("i", { staticClass: "el-icon-document cfl-empty-icon" }),
                _vm._v(" "),
                _c("p", [
                  _vm._v("No forms found. "),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.showAddFormModal = true
                        }
                      }
                    },
                    [_vm._v("Create your first form")]
                  ),
                  _vm._v(".")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "cfl-pagination",
        attrs: {
          background: "",
          "current-page": _vm.paginate.current_page,
          "page-sizes": [5, 10, 20, 50, 100],
          "page-size": parseInt(_vm.paginate.per_page),
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.totalForms
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.goToPage,
          "update:currentPage": function($event) {
            return _vm.$set(_vm.paginate, "current_page", $event)
          },
          "update:current-page": function($event) {
            return _vm.$set(_vm.paginate, "current_page", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("CreateNewFormModal", {
        attrs: { templates: _vm.templates, visibility: _vm.showAddFormModal },
        on: {
          "update:visibility": function($event) {
            _vm.showAddFormModal = $event
          },
          close: function($event) {
            _vm.showAddFormModal = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }